import React from 'react'
import { SafetyCertificateOutlined, CheckCircleOutlined, BulbOutlined, WarningOutlined } from '@ant-design/icons'

/** Shared icon/color identity per tier (NS-2668) — the single source both the full
 * decomposition and {@link BrandVoiceSummaryChips} render from, so a settings-page glance and
 * the full drawer always agree on what "Guaranteed" (etc) looks like. Split out on its own so
 * consumers that only need tier colors (e.g. the textarea<->rule highlight wiring) don't have
 * to import the whole decomposition module for it. */
export const BRAND_VOICE_TIER_VISUAL = {
    guaranteed: { icon: <SafetyCertificateOutlined />, color: 'var(--ant-color-success, #60c3ac)' },
    checked: { icon: <CheckCircleOutlined />, color: 'var(--ant-color-info, #464d53)' },
    guidance: { icon: <BulbOutlined />, color: 'var(--ant-color-text-tertiary, #838f9a)' },
    needsReview: { icon: <WarningOutlined />, color: 'var(--ant-color-warning, #f87635)' },
} as const
